import { sortDias } from './dias'

const BASE = {
  AZUL:      { key: 'AZUL',      label: 'Azul',      hex: '#1976d2', textColor: '#ffffff', icon: '★' },
  DOURADA:   { key: 'DOURADA',   label: 'Dourada',   hex: '#f59e0b', textColor: '#ffffff', icon: '◆' },
  VERMELHA:  { key: 'VERMELHA',  label: 'Vermelha',  hex: '#dc2626', textColor: '#ffffff', icon: '●' },
  LARANJA:   { key: 'LARANJA',   label: 'Laranja',   hex: '#ea580c', textColor: '#ffffff', icon: '▲' }
}

const LABEL_DIA = { QUI: 'Quinta', SEX: 'Sexta', SAB: 'Sábado', DOM: 'Domingo' }

function joinDias(dias) {
  if (dias.length === 1) return LABEL_DIA[dias[0]]
  if (dias.length === 2) return `${LABEL_DIA[dias[0]]} e ${LABEL_DIA[dias[1]]}`
  return dias.map(d => LABEL_DIA[d]).join(', ')
}

// Retorna lista de pulseiras a entregar pro acampante.
// Regras:
//   diasAcamp vazio (completo) → 1 pulseira AZUL.
//   Caso diaria, monta pulseiras por bloco:
//     - se contem QUI → DOURADA (usar na quinta)
//     - se contem SEX → VERMELHA (usar na sexta)
//     - se contem SAB e/ou DOM → LARANJA (usar nesses dias)
// Acampantes podem receber 1, 2 ou ate 3 pulseiras dependendo da combinacao.
export function pulseirasAcampante(acampanteOrDias) {
  const raw = Array.isArray(acampanteOrDias)
    ? acampanteOrDias
    : (acampanteOrDias?.diasAcamp || [])
  const dias = sortDias(raw)

  // Completo: 1 pulseira azul cobre todos os dias
  if (dias.length === 0) {
    return [{ ...BASE.AZUL, dias: ['QUI', 'SEX', 'SAB', 'DOM'], usoLabel: 'usar todos os dias' }]
  }

  const out = []

  if (dias.includes('QUI')) {
    out.push({ ...BASE.DOURADA, dias: ['QUI'], usoLabel: 'usar na Quinta' })
  }

  if (dias.includes('SEX')) {
    out.push({ ...BASE.VERMELHA, dias: ['SEX'], usoLabel: 'usar na Sexta' })
  }

  const fim = []
  if (dias.includes('SAB')) fim.push('SAB')
  if (dias.includes('DOM')) fim.push('DOM')
  if (fim.length > 0) {
    out.push({ ...BASE.LARANJA, dias: fim, usoLabel: `usar ${joinDias(fim)}` })
  }

  return out
}
